// src/api/LegalApi.js
import axios from 'axios';
import { handleApiError } from './handleApiError.js';

const baseUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

export const apiCheckCompliance = async (token) => {
  try {
    const response = await axios.get(`${baseUrl}/legal/api/check-compliance`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data; // { status: "success", pending: [...] }
  } catch (error) {
    return handleApiError(error, 'apiCheckCompliance');
  }
};

export const apiAcceptAgreement = async (token, versionId) => {
  try {
    const response = await axios.post(
      `${baseUrl}/legal/api/accept`,
      { versionId },
      { headers: { Authorization: `Bearer ${token}` } },
    );
    return response.data;
  } catch (error) {
    return handleApiError(error, 'apiAcceptAgreement');
  }
};
